jQuery(document).ready(function () {
  $('[data-bgimg]').each(function () {
    $(this).css('background-image', 'url(' + $(this).data('bgimg') + ')');
    $(this).addClass('bg-image');
  });
});